function options(data) {
    if (data) {
        let markup = ''
        for (let i = 0; i < data.length; i++) {
            markup += `<option value="${data[i].id}" ${
                data[i].selected ? 'selected' : ''
            }>${data[i].name}</option>`
        }
        return markup
    } else {
        return ''
    }
}

// prettier-ignore
const template = (data) => `
    <select class="select u-mb-30@small" name="filters[${data.handle}]" data-enabled="true" data-element="input" data-filter="related_solution" aria-label="Select ${data.handle.replace(/_/g, ' ')}" >
        ${data.handle === 'podcast_season' ? '<option value="all">'+ data.name + '</option>' : '<option value="">' + data.name + '</option>'}
        ${options(data.options)}
    </select>
    `
export default template
